// Demo data for client-side demo mode
// All data is served from memory — no backend calls

export const DEMO_USER = {
    id: 'demo-user-1',
    username: 'DemoUser',
    email: 'demo@folkpost.eu',
};

export const DEMO_POSTS = [
    {
        id: 'demo-post-1',
        content: 'Just visited the European Parliament in Strasbourg. The architecture is stunning and the debates were fascinating. Democracy in action! 🇪🇺',
        authorId: 'author-1',
        authorUsername: 'EuroTraveler',
        authorIconUrl: '/images/demo-author-1.svg',
        createdAt: '2026-02-19T08:30:00Z',
        likesCount: 24,
        commentsCount: 3,
    },
    {
        id: 'demo-post-2',
        content: 'New study shows that verified identity platforms reduce misinformation by 73%. This is exactly why FolkPost matters.\n\nSource: Digital Trust Institute, 2026',
        authorId: 'author-2',
        authorUsername: 'FactChecker',
        authorIconUrl: '/images/demo-author-2.svg',
        createdAt: '2026-02-19T07:15:00Z',
        likesCount: 42,
        commentsCount: 4,
    },
    {
        id: 'demo-post-3',
        content: 'Made fresh pasta from scratch today. The secret is really in the eggs — use the freshest ones you can find from a local farm. Simple ingredients, extraordinary results.',
        authorId: 'author-3',
        authorUsername: 'ItalianCook',
        authorIconUrl: '/images/demo-author-3.svg',
        createdAt: '2026-02-18T19:45:00Z',
        likesCount: 18,
        commentsCount: 2,
    },
    {
        id: 'demo-post-4',
        content: 'The northern lights were visible from Helsinki last night. Absolutely breathtaking display of greens and purples across the sky. Nature never ceases to amaze.',
        authorId: 'author-4',
        authorUsername: 'NordicNature',
        authorIconUrl: '/images/demo-author-4.svg',
        createdAt: '2026-02-18T16:20:00Z',
        likesCount: 67,
        commentsCount: 3,
    },
    {
        id: 'demo-post-5',
        content: 'Interesting development in renewable energy: Germany just hit 65% renewable electricity for the first time ever. Wind and solar are leading the charge.\n\nThe transition is happening faster than most models predicted even 5 years ago.',
        authorId: 'author-5',
        authorUsername: 'GreenEnergy',
        authorIconUrl: '/images/demo-author-5.svg',
        createdAt: '2026-02-18T14:00:00Z',
        likesCount: 35,
        commentsCount: 0,
    },
    {
        id: 'demo-post-6',
        content: 'Just finished reading "The Midnight Library" by Matt Haig. A beautiful reminder that every life has value and that our choices matter more than we think. Highly recommend! 📚',
        authorId: 'author-6',
        authorUsername: 'BookWorm',
        authorIconUrl: '/images/demo-author-6.svg',
        createdAt: '2026-02-18T11:30:00Z',
        likesCount: 29,
        commentsCount: 0,
    },
    {
        id: 'demo-post-7',
        content: 'Morning run along the Danube in Budapest. 10km in crisp winter air with the Chain Bridge in the background. Best way to start the day! 🏃‍♂️',
        authorId: 'author-7',
        authorUsername: 'RunnerLife',
        authorIconUrl: '/images/demo-author-7.svg',
        createdAt: '2026-02-17T22:00:00Z',
        likesCount: 15,
        commentsCount: 2,
    },
    {
        id: 'demo-post-8',
        content: 'The new GDPR enforcement report is out. Fines totaled €2.1 billion in 2025 — a clear signal that data privacy is being taken seriously.\n\nCompanies that invest in compliance early save significantly in the long run.\n\nKey sectors affected: AdTech, Social Media, Healthcare.',
        authorId: 'author-2',
        authorUsername: 'FactChecker',
        authorIconUrl: '/images/demo-author-2.svg',
        createdAt: '2026-02-17T15:45:00Z',
        likesCount: 51,
        commentsCount: 0,
    },
    {
        id: 'demo-post-9',
        content: 'Planted 50 trees this weekend with our local community group. Small actions, big impact over time. 🌳',
        authorId: 'author-8',
        authorUsername: 'EcoWarrior',
        authorIconUrl: '/images/demo-author-8.svg',
        createdAt: '2026-02-17T10:15:00Z',
        likesCount: 44,
        commentsCount: 0,
    },
    {
        id: 'demo-post-10',
        content: 'Attended a jazz concert in Amsterdam last night. Live music hits different when you\'re surrounded by people who genuinely love the art form. Support your local music scene! 🎵',
        authorId: 'author-9',
        authorUsername: 'MusicLover',
        authorIconUrl: '/images/demo-author-9.svg',
        createdAt: '2026-02-16T21:30:00Z',
        likesCount: 22,
        commentsCount: 0,
    },
];

// Comments keyed by post ID
export const DEMO_COMMENTS = {
    'demo-post-1': [
        {
            id: 'demo-comment-1',
            parentId: 'demo-post-1',
            content: 'I was there last month! The plenary sessions are really eye-opening.',
            authorId: 'author-5',
            authorUsername: 'GreenEnergy',
            authorIconUrl: '/images/demo-author-5.svg',
            createdAt: '2026-02-19T09:00:00Z',
            likesCount: 5,
        },
        {
            id: 'demo-comment-2',
            parentId: 'demo-post-1',
            content: 'Did you get a chance to visit the Hemicycle? The guided tour is excellent.',
            authorId: 'author-3',
            authorUsername: 'ItalianCook',
            authorIconUrl: '/images/demo-author-3.svg',
            createdAt: '2026-02-19T09:15:00Z',
            likesCount: 2,
        },
        {
            id: 'demo-comment-3',
            parentId: 'demo-post-1',
            content: 'Great to see people engaging with European institutions. We need more of this! 🇪🇺',
            authorId: 'author-6',
            authorUsername: 'BookWorm',
            authorIconUrl: '/images/demo-author-6.svg',
            createdAt: '2026-02-19T09:30:00Z',
            likesCount: 8,
        },
    ],
    'demo-post-2': [
        {
            id: 'demo-comment-4',
            parentId: 'demo-post-2',
            content: 'Can you share the link to the full study? Would love to read the methodology.',
            authorId: 'author-7',
            authorUsername: 'RunnerLife',
            authorIconUrl: '/images/demo-author-7.svg',
            createdAt: '2026-02-19T07:45:00Z',
            likesCount: 3,
        },
        {
            id: 'demo-comment-5',
            parentId: 'demo-post-2',
            content: 'This aligns with what we\'ve seen in our own research. Identity verification is a game changer.',
            authorId: 'author-8',
            authorUsername: 'EcoWarrior',
            authorIconUrl: '/images/demo-author-8.svg',
            createdAt: '2026-02-19T08:00:00Z',
            likesCount: 11,
        },
        {
            id: 'demo-comment-6',
            parentId: 'demo-post-2',
            content: 'The remaining 27% is still significant. What additional measures could help?',
            authorId: 'author-4',
            authorUsername: 'NordicNature',
            authorIconUrl: '/images/demo-author-4.svg',
            createdAt: '2026-02-19T08:20:00Z',
            likesCount: 6,
        },
        {
            id: 'demo-comment-7',
            parentId: 'demo-post-2',
            content: 'Shared this with my colleagues. Really important findings.',
            authorId: 'author-1',
            authorUsername: 'EuroTraveler',
            authorIconUrl: '/images/demo-author-1.svg',
            createdAt: '2026-02-19T08:45:00Z',
            likesCount: 1,
        },
    ],
    'demo-post-3': [
        {
            id: 'demo-comment-8',
            parentId: 'demo-post-3',
            content: 'What flour ratio do you use? I always struggle with getting the right texture.',
            authorId: 'author-9',
            authorUsername: 'MusicLover',
            authorIconUrl: '/images/demo-author-9.svg',
            createdAt: '2026-02-18T20:00:00Z',
            likesCount: 4,
        },
        {
            id: 'demo-comment-9',
            parentId: 'demo-post-3',
            content: 'Nothing beats homemade pasta. Store-bought doesn\'t even compare! 🍝',
            authorId: 'author-1',
            authorUsername: 'EuroTraveler',
            authorIconUrl: '/images/demo-author-1.svg',
            createdAt: '2026-02-18T20:30:00Z',
            likesCount: 7,
        },
    ],
    'demo-post-4': [
        {
            id: 'demo-comment-10',
            parentId: 'demo-post-4',
            content: 'So jealous! Been on my bucket list for years. Any tips for the best viewing spots?',
            authorId: 'author-3',
            authorUsername: 'ItalianCook',
            authorIconUrl: '/images/demo-author-3.svg',
            createdAt: '2026-02-18T17:00:00Z',
            likesCount: 3,
        },
        {
            id: 'demo-comment-11',
            parentId: 'demo-post-4',
            content: 'We saw them too from Rovaniemi! The geomagnetic storm made them extra vivid.',
            authorId: 'author-8',
            authorUsername: 'EcoWarrior',
            authorIconUrl: '/images/demo-author-8.svg',
            createdAt: '2026-02-18T17:30:00Z',
            likesCount: 9,
        },
        {
            id: 'demo-comment-12',
            parentId: 'demo-post-4',
            content: 'Nature\'s light show is truly humbling. Thanks for sharing! 💚',
            authorId: 'author-6',
            authorUsername: 'BookWorm',
            authorIconUrl: '/images/demo-author-6.svg',
            createdAt: '2026-02-18T18:00:00Z',
            likesCount: 5,
        },
    ],
    'demo-post-7': [
        {
            id: 'demo-comment-13',
            parentId: 'demo-post-7',
            content: 'Budapest is gorgeous for running. Try the Margaret Island loop next time!',
            authorId: 'author-4',
            authorUsername: 'NordicNature',
            authorIconUrl: '/images/demo-author-4.svg',
            createdAt: '2026-02-17T22:30:00Z',
            likesCount: 2,
        },
        {
            id: 'demo-comment-14',
            parentId: 'demo-post-7',
            content: 'What\'s your pace like in winter? I find the cold air makes me faster somehow.',
            authorId: 'author-5',
            authorUsername: 'GreenEnergy',
            authorIconUrl: '/images/demo-author-5.svg',
            createdAt: '2026-02-17T23:00:00Z',
            likesCount: 1,
        },
    ],
};
